module.exports = __webpack_public_path__ + "img/ИФ-1(А)-021-m.6b56a096.png";